import Vue from 'vue';

export default (context) => {
  context.airbnbActiveLoading = true;
  return Vue.$http.post('/airbnb/listings', {
    listings: context.listings,
    airbnb_account_id: context.currentAibnbAccountId,
  })
    .then((response) => {
      context.airbnbActiveLoading = false;
      toastr.success(context.$t('account.settings.user_platforms_section.synchro_airbnb_successfully'));
      return response;
    })
    .catch((error) => {
      console.log(error);
      context.airbnbActiveLoading = false;
    })
    .finally(() => {
    });
};



// WEBPACK FOOTER //
// ./src/app/services/airbnb/listing-create.js